import { Box, CircularProgress, FormControl, FormControlLabel, RadioGroup } from '@mui/material';
import React from 'react';
import { StyledRadio } from '../../../components/styles/StyledInputs';
import { StyledHeading } from '../../../components/styles/styles';
import { IRRUpdate } from '../../../models/IRRUpdate';

interface IRRPeriodSelectorProps {
  irrUpdates: IRRUpdate[];
  selectedLabel: string;
  dataLoading: boolean;
  onLabelChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * Inline "label beside its control" row layout, matching Fund Management's
   * Financial Updates section — used only by the embedded Cashflow Reports
   * section so the standalone Cashflow Reports page's layout stays unchanged.
   */
  compact?: boolean;
}

const IRRPeriodSelector: React.FC<IRRPeriodSelectorProps> = ({
  irrUpdates,
  selectedLabel,
  dataLoading,
  onLabelChange,
  compact = false,
}) => (
  <FormControl component="fieldset" sx={{ width: '100%', mb: 3 }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: compact ? 'row' : 'column',
        alignItems: compact ? 'center' : undefined,
        gap: compact ? 1.5 : undefined,
      }}
    >
      <StyledHeading
        headerVariant="subheading"
        reduceBottomPadding={!compact}
        sx={compact ? { m: 0, p: 0, whiteSpace: 'nowrap' } : undefined}
      >
        Select Update Period
      </StyledHeading>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          mt: compact ? 0 : 1,
        }}
      >
        <RadioGroup
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '1rem',
            opacity: dataLoading ? 0.5 : 1,
            pointerEvents: dataLoading ? 'none' : 'auto',
          }}
          name="update"
          value={selectedLabel}
          onChange={onLabelChange}
        >
          {irrUpdates.map((update) => (
            <FormControlLabel
              key={`${update.month}-${update.label}`}
              value={update.label}
              control={<StyledRadio size="small" />}
              label={update.label}
            />
          ))}
        </RadioGroup>
        {dataLoading && (
          <CircularProgress
            size={20}
            sx={{
              color: 'primary.main',
              ml: 1,
            }}
          />
        )}
      </Box>
    </Box>
  </FormControl>
);

export default IRRPeriodSelector;
